import { graphql } from "@opensea/graphql"

export const itemQuantitiesForQuoteFragment = graphql(`
  fragment itemQuantitiesForQuote on Quote {
    itemQuotes {
      __typename
      ... on WithQuoteItem {
        item {
          id
          tokenId
          contractAddress
          chain {
            identifier
          }
        }
      }
      ... on ItemQuote {
        pricePerItem {
          token {
            unit
            address
          }
        }
        quantity
        orderId
      }
      ... on ItemNotFound {
        item {
          tokenId
          chain {
            identifier
          }
          contractAddress
        }
      }
    }
  }
`)
